import { createContext, use } from 'react'

import type { TutorialSection } from '@/lib/github/types'
import { OS_MACOS } from '@/shared/components/QuickStartArticleSelectors/quick-start-article-selectors.const'

export type QuickStartLanguageContextValue = {
  sections: TutorialSection[]
  selectedLanguage: string | null
  setSelectedLanguage: (lang: string) => void
  availableLanguages: string[]
  selectedOs: string
  setSelectedOs: (os: string) => void
}

export const QuickStartLanguageContext = createContext<QuickStartLanguageContextValue>({
  sections: [],
  selectedLanguage: null,
  setSelectedLanguage: () => {},
  availableLanguages: [],
  selectedOs: OS_MACOS,
  setSelectedOs: () => {},
})

export function useQuickStartLanguageContext(): QuickStartLanguageContextValue {
  return use(QuickStartLanguageContext)
}
